export const BASE_PIXELS_PER_SECOND = 48;
export const MIN_ZOOM = 0.0005;
export const MAX_ZOOM = 12;
export const TRACK_HEADER_WIDTH = 164;

const finite = (value, fallback = 0) => Number.isFinite(value) ? value : fallback;
const bound = (value, min, max) => Math.min(max, Math.max(min, value));

export function clampZoom(value) {
  return bound(finite(value, 1), MIN_ZOOM, MAX_ZOOM);
}

export function pixelsPerSecond(zoom) {
  return BASE_PIXELS_PER_SECOND * clampZoom(zoom);
}

export function timeToPixels(time, zoom) {
  return finite(time) * pixelsPerSecond(zoom);
}

export function pixelsToTime(pixels, zoom) {
  return finite(pixels) / pixelsPerSecond(zoom);
}

export function clientXToTime(clientX, { left = 0, headerWidth = TRACK_HEADER_WIDTH, scrollLeft = 0, zoom = 1, duration = Infinity } = {}) {
  const local = finite(clientX) - finite(left) - finite(headerWidth) + Math.max(0, finite(scrollLeft));
  return bound(pixelsToTime(local, zoom), 0, Math.max(0, duration === Infinity ? Infinity : finite(duration)));
}

export function displayDuration(duration) {
  return Math.max(12, Math.max(0, finite(duration)) + 3);
}

export function timelineWidth(duration, zoom, usableWidth = 0) {
  return Math.max(0, finite(usableWidth), timeToPixels(displayDuration(duration), zoom));
}

export function fitZoom(duration, usableWidth) {
  const width = Math.max(0, finite(usableWidth));
  if (!width) return 1;
  return clampZoom(width / (displayDuration(duration) * BASE_PIXELS_PER_SECOND));
}

export function anchoredScrollLeft({ anchorTime, anchorPixel, zoom, maxScroll = Infinity }) {
  return bound(timeToPixels(anchorTime, zoom) - finite(anchorPixel), 0, Math.max(0, finite(maxScroll, Infinity)));
}

export function rulerStep(zoom) {
  const target = 72 / pixelsPerSecond(zoom);
  const magnitude = 10 ** Math.floor(Math.log10(target));
  const unit = [1, 2, 5, 10].find(value => value * magnitude >= target) || 10;
  return Math.max(0.1, unit * magnitude);
}

export function wheelPixels(delta, mode = 0, pageSize = 800) {
  return finite(delta) * (mode === 1 ? 16 : mode === 2 ? Math.max(1, finite(pageSize, 800)) : 1);
}
